<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

// PROPS
const props = defineProps({
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    class: { type: String, default: '' },
});

// DATA
const mergedClass = twMerge('mx-auto flex flex-col items-center justify-center gap-y-4 text-center max-w-[348px] text-left', props.class);
</script>

<template>
    <div :class="mergedClass">
        <div class="flex flex-col gap-y-1 md:gap-y-2 xl:gap-y-3">
            <p v-if="$slots.title || title" class="text-primary text-2xl font-semibold">
                <slot name="title">{{ title }}</slot>
            </p>
            <p v-if="$slots.title || description">
                <slot name="description">{{ description }}</slot>
            </p>
        </div>
    </div>
</template>
